export default {
  title: {
    roleManagement: 'Role Management',
    roleAdd: 'Add Role',
    roleEdit: 'Edit Role'
  },
  menu: 'Role Management',
  label: {
    roleName: 'Role Name',
    permissionSource: 'Available Permissions:',
    permissionTarget: 'Assigned Permissions:',

    company: 'Company',
    email: 'Email Address',
    role: 'Role',
    status: 'Status',
    option: 'Operation',
    companyName: 'Company Name',
    addUser: 'Add User',
    editUser: 'Edit User',
    firstName: 'First Name',
    lastName: 'Last Name',
    chineseName: 'Name in Chinese Characters',
    primaryEmail: 'Primary Email Address',
    secondaryEmail: 'Secondary Email Address',
    mobile: 'Mobile',
    employeeId: 'Employee ID',
    reportTo: 'Report To',
    programType: 'Program Type',
    clientName: 'Client Name',
    costCentre: 'Cost Center',
    roleType: 'Role Type',
    roleHead: "Assign {firstName} {lastName}'s Role at {company} {email}"
  },
  placeholder: {
    roleName: 'Please input role name',
    // u
    firstName: 'Please input first name',
    lastName: 'Please input last name',
    chineseName: 'Please input chinese name',
    company: 'Please select company',
    secondaryEmail: 'Please input secondary email',
    mobile: 'Please input mobile',
    employeeId: 'Please input employee id',
    reportTo: 'Please select report manager',
    programType: 'Please select program type',
    clientName: 'Please input client name',
    costCentre: 'Please input cost centre',
    roleType: 'Please select role type',
    role: 'Please select role',
    email: 'Please input email',
    primaryEmail: 'Please input primary email'
  },
  btn: {
    addRole: 'Add Role'
  },
  message: {
    optionSuccess: 'Option Success',
    optionField: 'Option Field',
    roleNameRequired: 'This field is required',
    titleExists: 'This name is used.',
    deleteConfirm: 'Are you sure to delete this role {roleName} ?',

    userTip: '{activeCount} Active Accounts(s) of {totalCount} Total Accounts Available.',
    userRequired: 'This field is required',
    emailExist: 'a user is already registered with this email address',
    emailValid: 'Enter a valid e-mail address.',
    mobileExist: 'The mobile number has already been bound.',
    resetPassword: 'Reset password email has sent, please check in few minutes.',
    expireDateClosed: 'Please contact AJINGA to add additional accounts'
  }
}
